export default __webpack_public_path__ + "static/media/vieworder.6221a164.svg";